import { TALKDESK_LOGO } from '../../constants/images'
import { LOGO_ALTERNATE_TEXT } from '../../constants/ui.labels'
import {
  LOGIN_CREDENTIALS_SUBTITLE,
  LOGIN_IDENTITY_PROVIDER_SUBTITLE
} from '../../constants/ui.labels'
import Image from '@talkdesk/cobalt-react-image'
import Flex from '@talkdesk/cobalt-react-flex'
import { Text } from '@talkdesk/cobalt-react-typography'
import { useTheme } from '@talkdesk/cobalt-react-theme-provider'
import { constantBuilder } from '../../utils/index'

const LoginHeader = props => {
  const theme = useTheme()
  const {
    localLoginEnabled,
    brandingSettings: {
      branding: { assets, name }
    }
  } = props

  return (
    <Flex direction="column" alignX="center" gap={4} paddingBottom={6}>
      {assets && (
        <Image
          src={TALKDESK_LOGO(assets)}
          alt={constantBuilder(LOGO_ALTERNATE_TEXT, { name })}
          height={32}
          width={160}
        />
      )}
      <Text color={theme.gray600}>
        {localLoginEnabled
          ? LOGIN_CREDENTIALS_SUBTITLE
          : LOGIN_IDENTITY_PROVIDER_SUBTITLE}
      </Text>
    </Flex>
  )
}

export default LoginHeader
